import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextUnderlinedFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 24a10.27 10.27 0 0 0 10-10.5V2h-4v11.5a6.27 6.27 0 0 1-6 6.5 6.27 6.27 0 0 1-6-6.5V2H6v11.5A10.27 10.27 0 0 0 16 24" />
    <path d="M4 26h24v4H4z" />
  </svg>
);
const ForwardRef = forwardRef(IconTextUnderlinedFilledSVG);
ForwardRef.displayName = "IconTextUnderlinedFilled";
export { ForwardRef as IconTextUnderlinedFilled };
